import { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { DashboardMemberChartAPI } from '@/api/type';
import { getDashboardMemberChart } from '@/api/Dashboard';
import { useTranslation } from 'react-i18next';

type Period = 'today' | '7_days' | '30_days';

export const NewRegistrationsChart = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<DashboardMemberChartAPI | undefined>(undefined);

  // Combine all data sources for the selected period
  const getCombinedData = () => {
    if (!data || !data.data) return [];

    const { labels, series } = data.data;

    return labels.map((label, index) => {
      const item: any = { 
        date: labels[index] 
      };
      series.forEach((s) => {
        if (s.name === 'Đăng ký mới (Gói)') {
          item.newRegistrations = s.data[index] || 0;
        } else if (s.name === 'Chưa thanh toán (Gói)' || s.name === 'Unpaid') {
          item.unpaid = s.data[index] || 0;
        } else if (
          s.name === 'Trễ hạn thanh toán (Gói)' ||
          s.name === 'Overdue'
        ) {
          item.overdue = s.data[index] || 0;
        }
      });
      return item;
    });
  };

  const chartData = getCombinedData();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const isDarkMode = document.documentElement.classList.contains('dark');

  useEffect(() => {
    // Fetch data when activePeriod changes
    getDashboardMemberChart().then(data => setData(data)).catch(() => { });
  }, []);

  return (
    <div className="!bg-white dark:!bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-dark-border">
      <div className="p-6 flex sm:items-center items-start sm:justify-between justify-start flex-col sm:flex-row">
        <div>
          <h2 className="text-xl font-bold !text-gray-900 dark:!text-white mb-1">
            {t('dashboard.registration_payment_overview')}
          </h2>
          <p className="text-sm !text-gray-500 dark:!text-dark-text-muted">
             {t('dashboard.year', { year: currentYear })}
          </p>
        </div>
      </div>

      <div className="p-6">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid
              strokeDasharray="3 3"
              stroke={isDarkMode ? '#2a2a2a' : '#e0e0e0'}
            />
            <XAxis
              dataKey="date"
              stroke={isDarkMode ? '#a0a0a0' : '#555555'}
              tick={{ fill: isDarkMode ? '#a0a0a0' : '#555555' }}
            />
            <YAxis
              stroke={isDarkMode ? '#a0a0a0' : '#555555'}
              tick={{ fill: isDarkMode ? '#a0a0a0' : '#555555' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
                border: `1px solid ${isDarkMode ? '#2a2a2a' : '#e0e0e0'}`,
                borderRadius: '8px',
                color: isDarkMode ? '#ffffff' : '#000000',
              }}
              labelStyle={{
                color: isDarkMode ? '#ffffff' : '#000000',
              }}
            />
            <Legend
              wrapperStyle={{
                color: isDarkMode ? '#a0a0a0' : '#555555',
              }}
            />
            <Line
              type="monotone"
              dataKey="overdue"
              stroke="#EF4444"
              strokeWidth={2}
              dot={{ fill: '#EF4444', r: 4 }}
              activeDot={{ r: 6 }}
              name={t('dashboard.overdue_payment')}
            />
            <Line
              type="monotone"
              dataKey="unpaid"
              stroke="#EAB308"
              strokeWidth={2}
              dot={{ fill: '#EAB308', r: 4 }}
              activeDot={{ r: 6 }}
              name={t('dashboard.unpaid')}
            />
            <Line
              type="monotone"
              dataKey="newRegistrations"
              stroke="#22C55E"
              strokeWidth={2}
              dot={{ fill: '#22C55E', r: 4 }}
              activeDot={{ r: 6 }}
              name={t('dashboard.new_registration')}
            />
          </LineChart>
          
        </ResponsiveContainer>
      </div>
    </div>
  );
};
